<template>
  <div class="main-content">
    <avue-crud
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
    >
      <template
        slot="menu"
        slot-scope="{ row }"
      >
        <el-button
          type="text"
          size="mini"
          v-if="row.id !== 'a031a43e40ca49c9a0694c9cfcad81f8'"
          icon="el-icon-edit"
          @click="handleEdit(row)"
        >编辑</el-button>
        <div v-else>-</div>
      </template>
    </avue-crud>

    <el-dialog
      v-if="dialogVisible"
      title="编辑"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
    >
      <avue-form
        ref="form"
        v-model="form"
        :option="formOption"
        @submit="submit"
      >
        <template slot="intimacy">
          <el-input
            v-model="form.intimacy"
            placeholder="请输入 所需亲昵度"
            onkeyup="this.value=this.value.replace(/[^\d]+/g,'')"
            @blur="salaryChange($event, 'intimacy', 999999)"
            type="text"
            clearable
          />
        </template>
        <template slot="discount">
          <el-input
            v-model="form.discount"
            placeholder="请输入 可享折扣"
            type="text"
            onkeyup="this.value=this.value.match(/\d+\.?\d{0,1}/)"
            @blur="salaryDianChange($event, 'discount', 1, 9.9)"
          />
        </template>
        <template slot="menuForm">
          <el-button
            icon="el-icon-close"
            @click="handleClose"
          >取消</el-button>
        </template>
      </avue-form>
    </el-dialog>
  </div>
</template>

<script>
import { list, update, view } from "@/api/level/discount";
export default {
  name: "index",
  data() {
    return {
      page: {
        total: 0,
        currentPage: 1,
      },
      tableData: [],
      showLoading: false,
      option: {
        title: "会员等级折扣设置",
        titleSize: "h3",
        card: true,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: true, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        selection: false, // 显示多选框
        page: false, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: "等级名称",
            prop: "levelName",
          },
          {
            label: "所需亲昵度",
            prop: "intimacy",
          },
          {
            label: "可享折扣",
            prop: "discount",
            formatter: function (row, column, cellValue) {
              return row.discount === 0 ? "-" : row.discount;
            },
          },
          {
            label: "更新时间",
            prop: "updateTime",
          },
          {
            label: "更新人",
            prop: "updateUsername",
          },
        ],
      },

      dialogVisible: false,
      form: {
        id: "",
        type: "",
        name: "",
      },
      formOption: {
        labelWidth: "100",
        submitText: "确定",
        emptyBtn: false,
        column: [
          {
            label: "等级名称",
            prop: "levelName",
            span: 24,
            maxlength: 12,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: "请输入等级名称",
                trigger: "blur",
              },
            ],
          },
          {
            label: "所需亲昵度",
            prop: "intimacy",
            type: "number",
            span: 24,
            value: 1,
            maxRows: 999999,
            minRows: 0,
            controls: false,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: "请输入所需亲昵度",
                trigger: "blur",
              },
            ],
          },
          {
            label: "可享折扣",
            prop: "discount",
            type: "number",
            span: 24,
            // value: 1,
            maxRows: 9.9,
            minRows: 1,
            controls: false,
            showWordLimit: true,
          },
        ],
      },
    };
  },
  created() {
    const searchForm = JSON.parse(localStorage.getItem("searchForm"));
    if (searchForm?.path === this.$route.path) {
      this.searchData = searchForm.searchData;
    } else {
      localStorage.removeItem("searchForm");
    }
  },
  methods: {
    onLoad() {
      this.showLoading = true;
      list({
        // page: this.page.currentPage,
        // size: this.page.pageSize,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          res.data.map((item) => {
            if (item.id === "a031a43e40ca49c9a0694c9cfcad81f8") {
              item.discount = "-";
              item.intimacy = "-";
              item.updateTime = "-";
              item.updateUsername = "-";
            }
          });
          this.tableData = res.data;
          //   this.page.total = res.data.total;
        }
      });
    },
    // 编辑
    async handleEdit(row) {
      // console.log('编辑',row)
      const { data } = await view({
        id: row.id,
      });
      // console.log(data)
      if (data.discount === 0) {
        data.discount = "";
      }
      this.form = data;
      this.dialogVisible = true;
    },
    // 提交
    submit(form, done) {
      update(form)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("操作成功");
            this.dialogVisible = false;
            setTimeout(() => {
              this.resetForm();
            }, 500);
            this.onLoad();
          } else {
            this.$message.error(res.msg);
            done();
          }
        })
        .catch(() => done());
    },
    // 关闭
    handleClose() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.resetForm();
      }, 500);
    },
    // 重置form
    resetForm() {
      this.form = {
        id: "",
        type: "",
        name: "",
      };
    },
    salaryChange(e, t, max) {
      const value = e.target.value;
      if (value) {
        if (isNaN(value * 1)) {
          this.form[t] = "";
          e.target.value = "";
        } else {
          if (value > max) {
            this.form[t] = max;
            e.target.value = max;
          } else {
            this.form[t] = value * 1;
            e.target.value = value * 1;
          }
        }
      } else {
        this.form[t] = "";
      }
    },
    salaryDianChange(e, t, min, max) {
      const value = e.target.value;
      if (value) {
        if (isNaN(value * 1)) {
          this.form[t] = "";
          e.target.value = "";
        } else {
          if (value > max) {
            this.form[t] = max.toFixed(1);
            e.target.value = max.toFixed(1);
          } else {
            if (value < min) {
              this.form[t] = min.toFixed(1);
              e.target.value = min.toFixed(1);
            } else {
              this.form[t] = parseFloat(value).toFixed(1);
              e.target.value = parseFloat(value).toFixed(1);
            }
          }
        }
      } else {
        this.form[t] = "";
      }
    },
  },
};
</script>

<style scoped></style>
